import React, { RefObject } from 'react';
import { useStyles, StyleSheet } from '@rexlabs/styling';

const headerLogoDefaultStyles = StyleSheet({
  logo: {
    height: '100%',
    width: 'auto',
    display: 'flex',
    flexDirection: 'column',
    flexShrink: 0,
    marginRight: '32px',
    boxSizing: 'border-box',
    minHeight: '32',
    padding: '5px 0'
  },
  'logo-link': {
    height: '100%',
    transitionProperty: 'opacity',
    transitionTimingFunction: 'cubic-bezier(0.4, 0, 0.2, 1)',
    transitionDuration: '500ms'
  },
  desktopLogo: {
    display: 'flex',
    height: '100%',
    width: 'auto',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    '@media(max-width: 1024px)': {
      display: 'none'
    }
  },
  mobileLogo: {
    display: 'none',
    '@media(max-width: 1024px)': {
      display: 'flex',
      height: '100%',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      maxWidth: '150px'
    }
  },
  boxedLogoContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    borderRadius: '0px 0px 10px 10px',
    display: 'flex',
    alignItems: 'center',
    boxSizing: 'border-box',
    padding: '12px',
    background: 'white',
    height: '90px',
    boxShadow:
      ' 0px 4px 8px rgba(34, 36, 42, 0.08), 0px 2px 8px rgba(34, 36, 42, 0.12)',
    '@media(max-width: 1440px)': {
      height: '110px'
    },
    '@media(max-width: 1024px)': {
      height: '90px'
    },
    '& > img': {
      width: 'auto',
      maxHeight: '66px',
      objectFit: 'contain',
      transform: 'translateZ(1px)',
      '@media(max-width: 1440px)': {
        maxHeight: '86px'
      },
      '@media(max-width: 1024px)': {
        maxHeight: '66px'
      }
    }
  }
});

interface Props {
  headerLogoRef: RefObject<HTMLDivElement>;
  desktopLogo: string;
  desktopLogoSize: number;
  mobileLogo?: string;
  mobileLogoSize?: number;
  isTransparent: boolean;
  transparentHideLogo: boolean;
  boxed: boolean;
  setOffset: () => void;
  logoAspectRatio: number;
}

export function HeaderLogo(props: Props) {
  const {
    headerLogoRef,
    desktopLogo,
    desktopLogoSize,
    mobileLogo,
    mobileLogoSize,
    isTransparent,
    transparentHideLogo,
    boxed,
    setOffset
  } = props;

  const s = useStyles(headerLogoDefaultStyles);
  return (
    <div ref={headerLogoRef} {...s('logo')}>
      <a
        href='/'
        {...s.with('logo-link')({
          display: isTransparent && transparentHideLogo ? 'none' : 'inherit'
        })}
      >
        {boxed ? (
          <>
            <div style={{ width: `${props.logoAspectRatio * 66 + 24}px` }}>
              <div {...s('boxedLogoContainer')}>
                <img alt='Logo' src={desktopLogo} onLoad={setOffset} />
              </div>
            </div>
          </>
        ) : (
          <>
            <div {...s('desktopLogo')}>
              <img
                alt='logo'
                src={desktopLogo}
                onLoad={setOffset}
                width={desktopLogoSize}
              />
            </div>
            <div {...s('mobileLogo')}>
              <img
                alt='logo'
                onLoad={setOffset}
                src={mobileLogo ?? desktopLogo}
                width={mobileLogoSize}
              />
            </div>
          </>
        )}
      </a>
    </div>
  );
}
